module.exports = __webpack_public_path__ + "static/media/night.f86cc283.svg";